import { Component, OnInit,ElementRef,ViewChild } from "@angular/core";
import { ViewWillEnter,IonContent  } from "@ionic/angular";
import { CanActivate, Router } from "@angular/router";
import { EmployeeListService } from "../../../../common/services/employee-listing.service"; ///app/common/services/employee-list.service';
import { RequestParams } from "../../../../common/rest-api/models/request-params"; //'src/core/shared/rest-api/models/request-params';
import { GtrakAuthService } from "../../../authentication/services/gtrak-auth.service";
import { ToasterService } from "../../../../common/services/toaster.service";
import { AccountManagementService } from "../../../account-management/services/account-management.service";
import { WebLoginDept } from "../../../account-management/models/web-login-dept.model";
import { ChangeDetectorRef } from '@angular/core';
import { isNumber } from "angular-pipes/utils/utils";
//Test data for ngxtable
const testData = require("../../../../common/test-data/report-data.json");

@Component({
  selector: "app-garment-return-review-page",
  templateUrl: "garment-return-review.page.html",
  styleUrls: ["./garment-return-review.page.scss"],
})
export class GarmentReturnReviewPage implements  OnInit {
  lastName: string;
  garmentCode: string;
  @ViewChild('content', { static: false }) content: IonContent;
  public rows: any;

  currentRoute: string;

  totalPages: number = 0;
  totalElements: number = 0;

  requestParams: any;

  currPage: number;
  pageSize: number;
costCenterString:string;
  submitting: boolean;
seachByGarmentCode:boolean=false
  loginDepts: WebLoginDept[];
  selectedCostCenter: string;
  customerCode: string;
  departmentCode: string;
  loaded:boolean;
  loadingData:boolean=false;
  constructor(
    private router: Router,
    private employeeListService: EmployeeListService,
    public authService: GtrakAuthService,
    public toasterService: ToasterService,
    private cd: ChangeDetectorRef,
    private accountManagementService: AccountManagementService
  ) {
    this.currentRoute = null;
  }

  async ngOnInit(): Promise<void> {
    this.loaded=false;
    if (this.authService.user?.isDriver) {
      this.router.navigate(["/route"]);
    }
    this.requestParams = new RequestParams();
    this.rows = [];
    this.currentRoute = this.router.url;
    this.currPage = 1;
    this.pageSize = 500;
    this.requestParams.setOrdering("LastName", "asc");
    await this.getCustomers();
    this.loaded=true;
  }

  async getCustomers(): Promise<void> {
    this.loaded=false;
    
    this.submitting = true;
    if(this.lastName==null){
       delete this.requestParams.filters.LastName;
    }
    else{
     this.requestParams.filters.LastName=this.lastName;
    }
    if(this.authService.user.customerCode!=""){
     this.requestParams.filters.CustomerCode=this.authService.user.customerCode;
    }
    this.requestParams.setPaging(this.currPage, this.pageSize);
    var employees = await this.employeeListService.getCustomerEmployees(this.requestParams);
    
    if(employees!=null){
      
    this.totalElements = employees.totalRecords;
    this.totalPages = employees.totalPages;
    this.rows = employees.results;
    this.submitting = false;
    }
    this.loaded=true;
  }


  async getDataByLastName(): Promise<void> {
    this.loaded=false;
    await this.getCustomers();
    this.loaded=true;
  }


  async setPage(event: { pageNumber: number, pageSize:number ;sortField?: string, sortDirection?: string }): Promise<void> {
        this.loaded = false;
        this.pageSize=event.pageSize;
        this.currPage = event.pageNumber;
        if(event.sortField==""){
             this.requestParams.setOrdering("LastName", "asc");
        }else{
        this.requestParams.setOrdering(event.sortField, event.sortDirection);

        }
    await this.getCustomers();
     this.content.scrollToTop(500);
     this.loaded=false;
  }

  changeCostCenter(event): void {
    this.selectedCostCenter = event;
  }
async onStopCodeFilter(stopCode: string) {
  this.loaded=false;
  this.lastName=stopCode;
  this.selectedCostCenter = 'All';
  this.cd.detectChanges();
  this.currPage = 1;
  this.requestParams.filters.StopCode =stopCode;
  this.rows = [];
  this.currentRoute = this.router.url;

  this.currPage = 1;
  this.pageSize = 500;

  this.requestParams.filters.ExcludeInactive = true;
  this.requestParams.setOrdering("LastName", "asc");
  await this.getCustomers();
  this.loaded=true
}
  onEnterKey(event: KeyboardEvent) {
      event.preventDefault();
      event.stopPropagation();
      this.getDataByLastName();
    }
}
